import React, { memo } from 'react';
import { Card } from 'react-bootstrap';

import PerfectScrollBar from 'react-perfect-scrollbar';
import { formatVolume10, numberFormat } from '../../../../utils';

import styled from 'styled-components';

const StyleTabBtn = styled.a`
  border-radius: 3px;
  font-size: 12px;
  padding: 2px 1rem;
  color: var(--white-50) !important;

  &.active {
    color: #ffffff !important;
    background-color: var(--primary);
  }
  :not(:last-of-type) {
    margin-right: 5px;
  }
`;

function CardTop(props) {
  const { typeIndex, topInterest, topVolume } = props;

  const [tabActive, setTabActive] = React.useState('TopBienDong');

  console.log(topInterest);

  return (
    <Card className={'card-top-info ml-1 type-index-' + typeIndex}>
      <Card.Header className="py-0 px-1">
        <StyleTabBtn
          className={tabActive === 'TopBienDong' ? 'active' : ''}
          onClick={() => setTabActive('TopBienDong')}
        >
          Top biến động
        </StyleTabBtn>
        <StyleTabBtn
          className={tabActive === 'TopKL' ? 'active' : ''}
          onClick={() => setTabActive('TopKL')}
        >
          Top KL giao dịch
        </StyleTabBtn>
      </Card.Header>
      <Card.Body className={typeIndex !== 1 ? 'pt-0' : ''}>
        <table className="table table-bordered table-fix">
          <thead>
            <tr>
              <th>{'Mã CK'}</th>
              <th>{'Giá'}</th>
              <th>% Thay đổi</th>
              <th>KL</th>
            </tr>
          </thead>
        </table>
        <PerfectScrollBar style={{ height: 'calc(100% - 26px)' }}>
          <table className="table table-bordered table-fix">
            <tbody>
              {tabActive === 'TopBienDong' &&
                topInterest &&
                !!topInterest.length &&
                topInterest.map((item, index) => (
                  <tr key={index}>
                    <td className="text-center">{item.STOCK_CODE}</td>
                    <td className={'text-center ' + item.COLOR}>
                      {numberFormat(item.PRICE, 2)}
                    </td>
                    <td className={'text-center ' + item.COLOR}>
                      {item.CHANGE} / {item.PERCENT_CHANGE}%
                    </td>
                    <td className="text-right">{formatVolume10(item.KLGD)}</td>
                  </tr>
                ))}
              {tabActive === 'TopKL' &&
                topVolume &&
                !!topVolume.length &&
                topVolume.map((item, index) => (
                  <tr key={index}>
                    <td className="text-center">{item.STOCK_CODE}</td>
                    <td className={'text-center ' + item.COLOR}>
                      {numberFormat(item.PRICE, 2)}
                    </td>
                    <td className={'text-center ' + item.COLOR}>
                      {item.CHANGE} / {item.PERCENT_CHANGE}%
                    </td>
                    <td className="text-right">{formatVolume10(item.KLGD)}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </PerfectScrollBar>
      </Card.Body>
    </Card>
  );
}

export default memo(CardTop);
